import { useEffect, useState } from "react";
import AthleteMonitoringFetchWrapper from "components/AthleteMonitoringFetchWrapper";
import { LocalisedLoadingContext } from "components/LocalisedLoadingProvider";
import logEvent from "utils/logEvent";
import MultiSelectProvider from "providers/MultiSelectProvider";
import SearchTextProvider from "providers/SearchTextProvider";
import SelectedEntitiesProvider from "providers/SelectedEntitiesProvider";
import TableSortProvider from "providers/TableSortProvider";
import { ALPHABETICAL_ASC } from "./AthleteTable/AthleteTableControls/AthleteTableControlSort/AthleteTableControlSort.helpers";
import useAthleteStore from "providers/AthletesProvider/useAthleteStore";
import AthleteHubContent from "./components/AthleteHubContent";
import useAthleteVelocityHotspot from "hooks/useAthleteVelocityHotspot";
import { athlete1RMV2Enabled, athleteProfilingV2Enabled } from "config/features";
import AthleteVelocityAnnouncementDialog from "./components/AthleteVelocityAnnouncementDialog";

function AthleteHub(props) {
  const athletes = useAthleteStore();
  const loadingState = useState(false);
  const athleteHotspot = useAthleteVelocityHotspot();

  useEffect(() => {
    logEvent("ATHLETES_VIEW_ALL");
  }, []);

  useEffect(() => {
    if (athleteHotspot.open) athleteHotspot.dismiss();
  }, [athleteHotspot]);

  return (
    <LocalisedLoadingContext.Provider value={loadingState}>
      <AthleteMonitoringFetchWrapper athletes={athletes}>
        <MultiSelectProvider>
          <SearchTextProvider>
            <SelectedEntitiesProvider>
              <TableSortProvider initialSortKey={ALPHABETICAL_ASC}>
                <AthleteHubContent />
              </TableSortProvider>
            </SelectedEntitiesProvider>
          </SearchTextProvider>
        </MultiSelectProvider>
      </AthleteMonitoringFetchWrapper>
      {athlete1RMV2Enabled || athleteProfilingV2Enabled ? <AthleteVelocityAnnouncementDialog /> : null}
    </LocalisedLoadingContext.Provider>
  );
}

export default AthleteHub;
